import loadable from "./loadable";

export default loadable;
